import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
import * as commonStyles from './common.style';
var colour = variables.colour,
  font = variables.font;
export var genericPanel = /*#__PURE__*/css(commonStyles.container, " display:flex;width:100%;flex-direction:column;gap:24px;", media('>=desktop'), "{flex-direction:row-reverse;justify-content:stretch;}");
export var content = {
  name: "i9gxme",
  styles: "flex-grow:1;"
};
export var title = commonStyles.title;
export var description = commonStyles.description;
export var legendList = _ref => {
  var columns = _ref.columns;
  return /*#__PURE__*/css("margin-left:16px;display:block;columns:", columns, ";", media('>=desktop'), "{float:right;}");
};
export var legendListItemSymbol = legendColour => /*#__PURE__*/css("display:inline-block;width:16px;height:16px;margin-right:5px;background-color:", legendColour, ";");
export var legendListItem = {
  name: "1cdckzz",
  styles: "display:block;white-space:nowrap;max-width:300px;"
};
export var legendListItemLabel = /*#__PURE__*/css("display:inline-block;vertical-align:top;font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";color:", colour.neutral700, ";");